import React from 'react';

const ClippyIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M20.17 19.5a2.5 2.5 0 1 1-5 0v-1.75a.75.75 0 1 1 1.5 0v1.75a1 1 0 0 0 2 0v-3.61c-.87-.28-1.5-1.02-1.5-1.89 0-1.1 1-2 2.25-2s2.25.9 2.25 2c0 .87-.63 1.61-1.5 1.89v3.61M13.42 12c1.25 0 2.25.9 2.25 2 0 .87-.63 1.61-1.5 1.89v5.36a3.25 3.25 0 1 0 6.5 0v-3.5a.75.75 0 1 1 1.5 0v3.5a4.75 4.75 0 1 1-9.5 0v-5.36c-.87-.28-1.5-1.02-1.5-1.89 0-1.1 1-2 2.25-2m1.81-1.87-.43 1.46c-.41-.22-.88-.34-1.38-.34-.91 0-1.72.4-2.22 1.02l-1.2-.9c.63-.8 1.58-1.37 2.67-1.56v-.06a3.75 3.75 0 0 1 7.5 0v.06c1.09.19 2.04.76 2.67 1.56l-1.2.9c-.5-.62-1.31-1.02-2.22-1.02-.5 0-.97.12-1.38.34l-.43-1.46c.33-.13.69-.26 1.06-.32v-.06c0-1.25-1-2.25-2.25-2.25s-2.25 1-2.25 2.25v.06c.37.06.73.19 1.06.32m4.19 3.12c-.55 0-1 .34-1 .75s.45.75 1 .75 1-.34 1-.75-.45-.75-1-.75m-6 0c-.55 0-1 .34-1 .75s.45.75 1 .75 1-.34 1-.75-.45-.75-1-.75z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default ClippyIcon;
